<template>
<div class="car-error-message">{{ $t('vehicleIdentification.noVehicleSelectionAvailable') }}</div>
</template>

<script>
export default {
  name: 'NoSelectionAllowed'
}
</script>
